module.exports = __webpack_public_path__ + "a30fa07d8d4813210e47812ce38a9001.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/middown-28.png
// module id = 2980
// module chunks = 0